import React, { createContext, useState } from 'react';

const AppStateContext = createContext();

const AppStateProvider = ({ children }) => {
    const storedLanguage = localStorage.getItem('selectedLanguage') || 'en'; // Default to 'en' if not found
    const [language, setLanguage] = useState(storedLanguage);

    const handleLanguageChange = (selectedValue) => {
        localStorage.setItem('selectedLanguage', selectedValue);
        setLanguage(selectedValue);
    };

    return (
        <AppStateContext.Provider value={{ language, setLanguage: handleLanguageChange }}>
            {children}
        </AppStateContext.Provider>
    );
};

export { AppStateContext, AppStateProvider };
